/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

import { defineLoader } from "intl-codegen/runtime";

export const loadLanguage = defineLoader([
  "addVoucher",
  "additionalInfoAddOns",
  "additionalInfoDesc",
  "additionalInfoMultiAnswerPatronQuestionSubtitle",
  "additionalInfoMultiAnswerPatronQuestionTitle",
  "additionalInfoPatronQuestion",
  "additionalInfoPoliciesEversportsGets",
  "additionalInfoPoliciesIAcceptTheTerm",
  "additionalInfoPoliciesPleaseAcceptTerms",
  "additionalInfoPoliciesPrivacyPolicy",
  "additionalInfoPoliciesTermsOf",
  "additionalInfoPoliciesTermsOfServicesPolicy",
  "additionalInfoPoliciesWhenYouBookOnline",
  "additionalInfoRequiredInfoDesc",
  "additionalInfoSubtitle",
  "additionalInfoTitle",
  "additionalPass",
  "all",
  "appPromotionContent",
  "appPromotionContentSelfCheckInStep1",
  "appPromotionContentSelfCheckInStep2",
  "appPromotionContentSelfCheckInStep3",
  "appPromotionHeading",
  "appPromotionHeadingSelfCheckIn",
  "applyVoucher",
  "assignedProductAutoExtensionDate",
  "assignedProductRemainingUsages",
  "assignedProductUsageLimitPeriod",
  "assignedProductValidUntil",
  "automaticExtension",
  "back",
  "blockingErrorMessage",
  "bookingConfirmationHeading",
  "bookingConfirmationHeadingNotConfirmed",
  "bookingConfirmationSubHeading",
  "bookingConfirmationSubHeadingNoConfirmed",
  "bookingConfirmationSubHeadingUnbranded",
  "bookingConfirmationSubHeadingWithoutSelfCheckIn",
  "bookingDetails",
  "bookingLimitation",
  "bookingPaymentConfirmationHeading",
  "bookingRules",
  "bookingRulesHeader",
  "cancelVoucher",
  "cancellationConditions",
  "cancellationPeriod",
  "cancellationPeriodInterval",
  "collapseDetails",
  "confirmationButtonInviteFriends",
  "confirmationButtonMyBookings",
  "confirmationButtonMyRecording",
  "confirmationButtonMyRecordings",
  "confirmationButtonWebsite",
  "corporateBenefit",
  "corporateBenefitsLearnMore",
  "corporateBenefitsPricingToggle",
  "corporateBudgetDefaultName",
  "corporateBudgetEmployeeBudgetDepleted",
  "corporateBudgetProvidedBy",
  "corporateBudgetSharedInformationAmount",
  "corporateBudgetSharedInformationDataProtectionLink",
  "corporateBudgetSharedInformationDate",
  "corporateBudgetSharedInformationEmail",
  "corporateBudgetSharedInformationLegalBasis",
  "corporateBudgetSharedInformationName",
  "corporateBudgetSharedInformationPurpose",
  "corporateBudgetSharedInformationText",
  "corporateBudgetSharedInformationTitle",
  "corporateBudgetTotalBudgetDepleted",
  "corporatePricingBudgetLabel",
  "corporatePricingDiscountLabel",
  "courtBookingDetailsName",
  "courtbookingCommentboxHeading",
  "dateUnitDay",
  "dateUnitDayPlural",
  "dateUnitGame",
  "dateUnitGamePlural",
  "dateUnitHour",
  "dateUnitHourPlural",
  "dateUnitMinute",
  "dateUnitMinutePlural",
  "dateUnitMonth",
  "dateUnitMonthPlural",
  "dateUnitSeason",
  "dateUnitSeasonPlural",
  "dateUnitUnit",
  "dateUnitUnitPlural",
  "dateUnitWeek",
  "dateUnitWeekPlural",
  "dateUnitWeekend",
  "dateUnitWeekendPlural",
  "dateUnitYear",
  "dateUnitYearPlural",
  "dateAndTime",
  "downloadInvoice",
  "downloadVoucher",
  "emptyActivities",
  "endTime",
  "enterYourCommentHere",
  "eventBookingDetailsName",
  "eversports",
  "eversportsDataProtectionDeclaration",
  "expandDetails",
  "fieldBirthday",
  "fieldCity",
  "fieldCountry",
  "fieldDetail",
  "fieldFiscalCode",
  "fieldFiscalCodeDisclaimer",
  "fieldPhoneNumber",
  "fieldStreet",
  "fieldZip",
  "firstPartialPaymentInfo",
  "freeProductConfirmationHeading",
  "headerSecureCheckout",
  "hideVoucherRedemption",
  "howWouldLikeBookCourt",
  "idealPaymentSelectYourBank",
  "includedActivities",
  "incorrectUser",
  "incorrectUserDescription",
  "interval",
  "intervalIncludingSingleNumber",
  "invoiceAndPurchaseConfirmationHeading",
  "invoiceAndPurchaseConfirmationSubHeading",
  "invoiceFrom",
  "invoiceNumber",
  "membership",
  "membershipCancelAnytime",
  "membershipConditions",
  "membershipDueDate",
  "membershipInterval",
  "membershipMinRuntime",
  "membershipModalInterval",
  "membershipPaymentInformation",
  "membershipPaymentTermsInfo",
  "membershipPaymentTermsTitle",
  "membershipPrice",
  "membershipPromotionSummary",
  "membershipRuntime",
  "membershipStartingDate",
  "membershipUsages",
  "month",
  "monthlyAvailabilityPeriod",
  "multiDayAvailabilityPeriod",
  "multiSessionEvent",
  "multiSessionSharingMessage",
  "myPasses",
  "networkErrorDescription",
  "networkErrorMessage",
  "newPass",
  "next",
  "no",
  "noAvailableProductForOnlinePurchase",
  "noPaymentMethodAvailable",
  "numberAddOnPlaceholder",
  "orderAbortedError",
  "orderAlreadyConfirmed",
  "orderTimeoutError",
  "partialPayment",
  "partialPaymentDisclaimer",
  "partialPaymentInterval",
  "partialPaymentPeriod",
  "participationOptions",
  "patronageAnswerEversports",
  "patronageAnswerVenueChannels",
  "patronageAnswerVenueCustomer",
  "patronageAnswerVenueMembers",
  "payOffline",
  "payWith",
  "payWithSepa",
  "paymentUnitEuro",
  "paymentAdditionalPaymentMethodsApplePay",
  "paymentAdditionalPaymentMethodsBancontact",
  "paymentAdditionalPaymentMethodsGooglePay",
  "paymentAdditionalPaymentMethodsHeading",
  "paymentAdditionalPaymentMethodsIdeal",
  "paymentAdditionalPaymentMethodsMastercard",
  "paymentAdditionalPaymentMethodsMultibanco",
  "paymentAdditionalPaymentMethodsPayOnSite",
  "paymentAdditionalPaymentMethodsPayWith",
  "paymentAdditionalPaymentMethodsPaypal",
  "paymentAdditionalPaymentMethodsSepa",
  "paymentAdditionalPaymentMethodsTwint",
  "paymentAdditionalPaymentMethodsVisa",
  "paymentChargeInfo",
  "paymentDetails",
  "paymentErrorCancelled",
  "paymentErrorFailed",
  "paymentErrorRequestTimeout",
  "paymentErrorStripeSource",
  "paymentHeading",
  "paymentMethodInformation",
  "paymentMethodOfflineInformation",
  "paymentPayWithCreditCardAddNewCard",
  "paymentPayWithCreditCardAddNewCreditCard",
  "paymentPayWithCreditCardHeading",
  "paymentPayWithCreditCardSavedCreditCards",
  "paymentPayWithIdealHeading",
  "paymentPayWithSepaIdealHeading",
  "paymentProviderTitle",
  "paymentTimer",
  "periodOfValidity",
  "pleaseChooseAnOption",
  "pleaseEnterAVoucher",
  "poweredByStripe",
  "preparingYourOrder",
  "price",
  "processingPayment",
  "product",
  "productBookingRules",
  "productConditionsTitle",
  "productDescription",
  "productDetails",
  "productInfo",
  "productPrice",
  "productSupportedVenues",
  "productUsageConditions",
  "productValidityConditions",
  "productValidityStart",
  "purchaseConfirmationSubHeading",
  "recordingAvailableUntil",
  "recordingDetails",
  "recordingOriginalStreamingTime",
  "recordingTrainer",
  "returnToLogin",
  "saveCard",
  "security",
  "sepaAgreement",
  "sepaBankAccountHolder",
  "sepaDisclaimer",
  "sepaNewBankAccount",
  "sepaPaymentInformation",
  "sepaSavedBankAccountHeader",
  "sepaUnverifiedBankAccount",
  "sepaVerifyWithPaymentInformation",
  "shareIt",
  "shareWithFriends",
  "showLess",
  "showMore",
  "showVoucherRedemption",
  "singleDayAvailabilityPeriod",
  "singlePurchase",
  "singleSessionSharingMessage",
  "singleTimeBlock",
  "sofortPaymentSelectYourBankCountry",
  "startOfRegularRuntime",
  "startTime",
  "startingDate",
  "stepAdditionalInformation",
  "stepChooseActivity",
  "stepChooseProduct",
  "stepChooseVideo",
  "stepConfirmation",
  "stepPayment",
  "stepReviewInformation",
  "summaryButtonBookNow",
  "summaryButtonConfirm",
  "summaryButtonContinue",
  "summaryButtonPay",
  "summaryChooseProduct",
  "summaryPartialPaymentPeriod",
  "summaryParticipateWith",
  "summaryStartOfRegularRuntime",
  "summaryTitle",
  "summaryTotal",
  "summaryTotalVat",
  "testText",
  "textAddOnPlaceholder",
  "ticketEarlyBirdDisclaimer",
  "ticketEarlyBirdPrice",
  "ticketEarlyBirdUntil",
  "ticketEarlyBirdValidUntil",
  "ticketLastMinutePrice",
  "ticketRegularPrice",
  "ticketsIncludedSessions",
  "timeLimit",
  "timeRestrictions",
  "trialOffers",
  "unexpectedErrorDescription",
  "unexpectedErrorMessage",
  "units",
  "unitsHeader",
  "unlimitedMembershipUsage",
  "validActivities",
  "validAt",
  "validForInterval",
  "validOnlyForThisEvent",
  "validSports",
  "validityStart",
  "voucherCode",
  "voucherConditions",
  "voucherDisclaimer",
  "voucherExpirationDate",
  "voucherPurchaseInformation",
  "voucherSuccessfullyApplied",
  "voucherValidUntil",
  "weekday",
  "weekdayPeriods",
  "yes",
  "yourBookingDetails",
  "yourPaymentDetails",
], {
  de: () => import("./locales/de.js"),
  en: () => import("./locales/en.js"),
  es: () => import("./locales/es.js"),
  nl: () => import("./locales/nl.js"),
  fr: () => import("./locales/fr.js"),
  it: () => import("./locales/it.js"),
}, "en");
